import React, { useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const Login = () => {
    const [formerror, setFormError] = useState('')
    const [loader, setLoader] = useState(false)
    const [user, setUser] = useState({
        username: '',
        password: '',
    });

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setUser(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        });
    }

    const removeError = (e) => {
        setFormError('')
    }

    const getLogin = async (e) => {
        e.preventDefault();
        setFormError('');
        setLoader(true);
        if (user.username !== '' && user.password !== '') {
            try {
                await axios.post(
                    localStorage.getItem('basurl') + '/login', {
                    username: user.username,
                    password: user.password,
                }
                ).then(response => {
                    localStorage.setItem("user", JSON.stringify(response.data.user));
                    window.location.href = '/';
                }).catch(error => {
                    setLoader(false);
                    if(error.response){
                        //console.log(1, error.response);
                        setFormError(error.response.data.message);                    
                    } else {
                        //console.log(1, error.data);
                        setFormError(error.message);                    
                    }
                });
            } catch (error) {
                setLoader(false);
                console.error(2, error.message);
                setFormError(error.message)
            }
        } else{
            setLoader(false);
            setFormError('Please provide username and password details.')
        }
    }

    return (<>
        <div className="d-flex align-items-center justify-content-center bg-br-primary ht-100v">
            <div className="login-wrapper wd-300 wd-xs-350 pd-25 pd-xs-40 bg-white rounded shadow-base">
                <div className="signin-logo tx-center tx-28 tx-bold tx-inverse"><span className="tx-normal"><img src="/images/mojo.png" alt="MOJO"/></span></div>
                <div className="tx-center mg-b-35">Mobile Friendly Solution</div>
                <span className="text-danger">{formerror}</span>
                <form onSubmit={getLogin}>
                    <div className="form-group input-group">
                        <span className="input-group-addon"><i className="icon ion-person tx-16 lh-0 op-6"></i></span>
                        <input name="username" type="text" className="form-control" placeholder="Enter loginid/email/phone" onFocus={removeError} onKeyUp={handleChange} />
                    </div>
                    <div className="form-group input-group">
                        <span className="input-group-addon"><i className="icon ion-key tx-16 lh-0 op-6"></i></span>
                        <input name="password" type="password" className="form-control" placeholder="Enter password" autoComplete="off" onFocus={removeError} onKeyUp={handleChange} />
                    </div>
                    <NavLink to="/forgot" className="tx-info tx-16 d-block mg-t-5 mg-b-10">Forgot password?</NavLink>
                    {loader?<><span className="btn btn-info btn-block">Please Wait...</span></>:<input type="submit" className="btn btn-info btn-block" value="Sign In" style={{ cursor: 'pointer' }} />}                    
                </form>
                <div className="mg-t-40 tx-center tx-16">Not yet a member? <NavLink to="/register" className="tx-info">Sign Up</NavLink></div>
            </div>
        </div>
    </>)
}
export default Login;